import { useContext } from 'react';
import { RouterControllerContext } from '../routerContext';
export function usePrefetch() {
    return useContext(RouterControllerContext).prefetch;
}
